<template>
  <div class="panel-vs-wrapper" v-if="elements">
    <div>
      <div v-for="(item, index) in elements" :key="item.id" style="position: absolute;">
        <ElementBox
          :type="item.type" :ref="item.id" :element="item" :index="index"
          v-if="item.type !== 'group' && (!item.isHidden || item.isHidden == null)"
        >
        </ElementBox>
        <GroupBox
          :type="item.type" :group="item" :id="item.id" :index="index"
          v-else-if="!item.isHidden || item.isHidden == null"
        >
        </GroupBox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pages',
  components: {
  },
  props: ['elements'],
  data () {
    return {
    }
  },
  mounted () {
  },
  watch: {
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  .editor-modal{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2007;
    background-color: #000;
    opacity: 0.3;
  }
  .process-text{
    font-size: 26px;
    position: fixed;
    top: calc(50vh - 50px);
    z-index: 2008;
    left: 50%;
    color: #fff;
    font-family: [SourceHanSansCN];
    transform: translate(-50%);
  }
.panel-wrapper {
  position: relative;
  overflow: hidden;
}
.render-wrapper {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
}
</style>

<style>
.panel-vs-wrapper {
  width: 100%;
  height: 100%;
}
.ivu-loading-bar {
    width: 30%;
    position: fixed;
    top: 50%;
    left: 50%;
    right: 0;
    z-index: 2008;
    transform: translate(-50%);
    background: #525252;
    border-radius: 10px;
}
.ivu-loading-bar-inner {
    transition: width .2s linear;
    border-radius: 10px;
    }
#player,
#streamingVideo,
#videoPlayOverlay {
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  /* right: 0 !important;
  bottom: 0 !important; */
  position: relative !important;
  background: none !important;
}
</style>
